import { useState } from "react";
import Container from "../Container";
import ContentRating from "./ContenRating/ContenRating";
import ContentAfterSendRating from "./ContentAfterSendRating/ContentAfterSendRating";
import "./style.css";

interface SatisfyCartProps {
  saleId: number | null;
}

const SatisfyCart = ({ saleId }: SatisfyCartProps) => {
  const [showAcknowledgment, setShowAcknowledgment] = useState(false);

  return (
    <div>
      <Container
        as="main"
        className="mt-4 box-border flex w-auto flex-col items-center justify-center rounded-lg p-6 shadow-lg"
      >
        <div className={(showAcknowledgment && "hide") || "contentRating"}>
          <ContentRating
            saleId={saleId}
            setShowAcknowledgment={setShowAcknowledgment}
          />
        </div>
        <div className={(showAcknowledgment && "contentRating") || "hide"}>
          <ContentAfterSendRating
            setShowAcknowledgment={setShowAcknowledgment}
          />
        </div>
      </Container>
    </div>
  );
};

export default SatisfyCart;
